import ModalService from './ModalService'

const ID_SNACKBAR = 'c2b-new-update-snackbar'
const TIMEOUT = 30 * 1000
let idTimeout = 0

export default {
    show() {
        clearTimeout(idTimeout)

        document.getElementById(ID_SNACKBAR)?.classList.add('active')

        idTimeout = setTimeout(() => {
            this.hide()
        }, TIMEOUT)
    },
    hide() {
        document.getElementById(ID_SNACKBAR)?.classList.remove('active')
    },
}
